import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmActionForm from '../../../components/forms/FirearmActionForm';
import { useFirearmActionById, useUpdateFirearmAction } from '../../../hooks/useFirearmActionApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmActionDTO } from '../../../services/apiClient';

const FirearmActionEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmActionById(id!);
  const updateFirearmAction = useUpdateFirearmAction();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Actions', href: '/admin/firearmactions' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmAction.mutateAsync({ id: id!, data });
      navigate('/admin/firearmactions');
    } catch (error) {
      console.error('Error updating FirearmAction:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmactions"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmAction.Edit'
    >
        {entityData ? (
          <FirearmActionForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmactions')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmActionEdit;